/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Firstname_Required1Inputs */

const en_onboarding_firstname_required1 = /** @type {(inputs: Onboarding_Firstname_Required1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please enter your first name.`)
};

const fr_onboarding_firstname_required1 = /** @type {(inputs: Onboarding_Firstname_Required1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veuillez entrer votre prénom.`)
};

/**
* | output |
* | --- |
* | "Please enter your first name." |
*
* @param {Onboarding_Firstname_Required1Inputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
const onboarding_firstname_required1 = /** @type {((inputs?: Onboarding_Firstname_Required1Inputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Firstname_Required1Inputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onboarding_firstname_required1(inputs)
	return fr_onboarding_firstname_required1(inputs)
});
export { onboarding_firstname_required1 as "onboarding_firstName_required" }